import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  width: 40%;
  background: #0a1e32;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 4rem 3rem;
  text-align: left;
  position: fixed;

  @media (min-width: 1024px) {
    padding: 4rem 6rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    position: static;
    height: auto;
  }
`;

export const Title = styled.h1`
  color: #fff;
  font-family: "JetBrains Mono", monospace;
  font-size: 1.4rem;
  line-height: 30px;
  text-align: left;
  width: 100%;
  margin: 2.8rem 0;

  b {
    font-size: 1.4rem;
  }

  @media (max-width: 414px) {
    width: 100%;
  }
`;

export const Text = styled.p`
  color: #fff;
  font-family: "Roboto", sans-serif;
  font-size: 1.2rem;
  width: 100%;
  margin-top: 2.2rem;
  line-height: 1.5rem;
  b {
    font-size: 1.2rem;
  }
`;
